import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import TopNav from "./TopNav";
import Logo from "../Images/logo.png";
import { FiArrowUpRight } from "react-icons/fi";


export const menuItems = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Services", path: "/services" },
  // { name: "Projects", path: "/projects" },
];

const Navbar = () => {
  const location = useLocation();
  const [active, setActive] = useState("Home");
  const [menuOpen, setMenuOpen] = useState(false);

  // Only these 4 should show indicator
  // const menuItems = [
  //   { name: "Home", path: "/" },
  //   { name: "About", path: "/about" },
  //   { name: "Services", path: "/services" },
  //   { name: "Projects", path: "/projects" },
  // ];

  // Auto-detect active page
  useEffect(() => {
    const found = menuItems.find((item) => item.path === location.pathname);
    setActive(found ? found.name : "");
  }, [location.pathname]);
  

  const toggleMenu = () => setMenuOpen(!menuOpen);

    useEffect(() => {
    window.scrollTo(0, 0);
    }, []);


  return (
    <div>
      <TopNav />

      <header className="navbar">
        <div className="nav-container">

          {/* Logo */}
          <div className="nav-logo">
              <Link to='/'>
            <div className="nav_logo">
              <img src={Logo} alt="logo" />
              <div className="brand-text">
                <h3>Well Clean</h3>
                <p>Oil Services</p>
              </div>
            </div>
              </Link>
          </div>

          {/* Hamburger (turns to X) */}
          <div className="hamburger" onClick={toggleMenu}>
            <div className={`bar ${menuOpen ? "open rotate1" : ""}`}></div>
            <div className={`bar ${menuOpen ? "open fade" : ""}`}></div>
            <div className={`bar ${menuOpen ? "open rotate2" : ""}`}></div>
          </div>

          {/* Menu */}
          <nav className={`nav-links ${menuOpen ? "active-menu" : ""}`}>
            <div className="nav_link">
              {menuItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`nav-item ${active === item.name ? "active" : ""}`}
                  onClick={() => setMenuOpen(false)}
                >
                  {item.name}

                  {/* indicator only for selected pages */}
                  {active === item.name && <span className="indicator"></span>}
                </Link>
              ))}
            </div>

            {/* Contact — NO indicator */}
            <Link to="/contact" onClick={() => setMenuOpen(false)}>
              <div className="contactBtn">
                <button className="contact-btn">Contact us</button>
                <button className="contact-btn">
                  <FiArrowUpRight size={24} />
                </button>
              </div>
            </Link>

          </nav>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
